import React from 'react';

import BackgroundImage from '../assets/background_start.png';
import BackgroundImageFrutas from '../assets/background_frutas_white.png';

import { useNavigate } from 'react-router-dom'

import {
    ArrowLeftOutlined,
    WhatsAppOutlined,
    MailOutlined,
} from '@ant-design/icons'

import './SAC.scss';

const SAC = () => {
    let navigate = useNavigate()

    const onClickBack = () => {
        console.log('click')
        navigate('/', { replace: true })
    }
    return (
        <div className='sac' style={{ backgroundImage: `url(${BackgroundImage})` }}>
            <div className='sac__backButton'>
                <ArrowLeftOutlined className="sac__icons" onClick={onClickBack} />
            </div>
            <div className='sac__title'>
                <p style={{ paddingTop: 12 }}>SAC</p>
            </div>
            <div className='sac__body'>
                <p>Em caso de dúvida, reclamação ou sugestão</p>
            </div>
            <div style={{marginTop:100}}>
                <div className='sac__bodysac' style={{marginTop:-20}}>
                    <MailOutlined className="sac__sacIcons" />
                    <p className='sac__text'>Entre em contato pelo e-mail:</p>
                </div>
                <div className='sac__bodyWhats' style={{marginTop:20}}>
                    <p className='sac__textWhats'><b>nutricaometabolicahcpa@gmail.com</b></p>
                </div>
            </div>
            <div className='sac__footerImage' style={{ backgroundImage: `url(${BackgroundImageFrutas})` }}/>
        </div>
    )
}

export default SAC